import produce from 'immer';
import { combineReducers } from 'redux';
import { ActivityRunActionType, ActivityRunAction } from '../../actions/activityRunActions';

const loading = (state = false, action: ActivityRunAction) => {
  switch (action.type) {
    case ActivityRunActionType.GET_ACTIVITY_RUNS:
      return true;
    case ActivityRunActionType.GET_ACTIVITY_RUNS_OK:
    case ActivityRunActionType.GET_ACTIVITY_RUNS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ActivityRunAction) => {
  switch (action.type) {
    case ActivityRunActionType.GET_ACTIVITY_RUNS:
      return '';
    case ActivityRunActionType.GET_ACTIVITY_RUNS_ERROR:
      return action.error;
    default:
      return state;
  }
};

type LoadingState = { loading: boolean; loadingError: string };

export type ActivityRunState = LoadingState;

type ActivityRunStateMap = {
  [id: string]: ActivityRunState;
};

const byId = (state: ActivityRunStateMap = {}, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUNS_OK: {
        action.data.forEach((aRun) => {
          draft[aRun.id] = {} as ActivityRunState;
        });

        break;
      }
      case ActivityRunActionType.SET_ACTIVITY_RUN: {
        draft[action.activityRun.id] = {} as ActivityRunState;
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN: {
        draft[action.activityRunId] = {
          ...draft[action.activityRunId],
          loading: true,
          loadingError: '',
        };
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN_OK: {
        draft[action.activityRunId].loading = false;
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN_ERROR: {
        draft[action.activityRunId].loading = false;
        draft[action.activityRunId].loadingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({ loading, loadingError, byId });
